import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { api } from 'services/api/api';
import authReducer from './authSlice';
import operationsParamsReducer from './operationsParamsSlice';
import dentistsReducer from './dentistsSlice';
import practicesReducer from './practicesSlice';
import billsReducer from './billsSlice';
import paymentsReducer from './paymentsSlice';
import discountsReducer from './discountsSlice';
import thirdPatiesReducer from './thirdPartiesSlice';
import educationContentReducer from './educationContentSlice';
import eduContentForDentistReducer from './eduContentForDentistSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const reducers = combineReducers({
  [api.reducerPath]: api.reducer,
  auth: authReducer,
  operationsParams: operationsParamsReducer,
  dentists: dentistsReducer,
  practices: practicesReducer,
  bills: billsReducer,
  payments: paymentsReducer,
  discounts: discountsReducer,
  thirdParties: thirdPatiesReducer,
  educationContent: educationContentReducer,
  eduContent: eduContentForDentistReducer,
});

export const middlewares = [api.middleware];

export default persistReducer(persistConfig, reducers);
